<template>
    <nav>
        <router-link to="/">Home</router-link>
        <router-link to="/login">Login</router-link>
        <router-link to="/dashboard">Dashboard</router-link>
        <router-link to="/register">Register</router-link>
        <router-link to="/pro">Pro</router-link>
        <router-link to="/faq">FAQ</router-link>
        <router-link to="/about">About</router-link>
    </nav>
</template>

<script>
    export default {}
</script>

<style scoped>
    nav {
        grid-column: 1 / 4;
        text-align: right;
        padding:1em;
    }

    a{
        margin:1em;
    }
</style>